import { IExerciseMedia } from '../domains/Exercise';

// Item de posição 0, se existir -- é o que qualquer lista mostra (o
// pedido é "manter apenas uma imagem" na lista, foto ou vídeo, sempre
// via thumbnail_url; pra vídeo isso já é o poster gerado no upload).
const getExercisePrimaryMedia = (
  media: IExerciseMedia[] | undefined,
): IExerciseMedia | undefined => media?.find(item => item.position === 0);

export { getExercisePrimaryMedia };
